/* ------------------------------------------------------------------------ */
/*		File: cmpBreadcumb.tsx                                              */
/*		Description: Component Implementation                               */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */

import React from "react";
import { ICard } from "./cmpBreadcumb.d";
import "./cmpBreadcumb.css"

/* ------------------------------------------------------------------------ */

const Card_Breadcumb: React.FC<ICard> = (props) => {
    const breadcumb = props.label.split(">");

    return (
        <div className="card_breadcumb">
            {breadcumb.map((item, index) => {
                if (index < breadcumb.length-1) {
                    return (
                        <div 
                            key={`breadcumb-${index}`}
                            className="card_breadcumb_label"
                        >
                            {item}
                            <span>{`>`}</span>
                        </div>
                    )
                } else {
                    return (
                        <div 
                            key={`breadcumb-${index}`}
                            className="card_breadcumb_label blue"
                        >
                            {`${item}`}
                        </div>
                    )
                }
            })}
        </div>
    );
};

export default Card_Breadcumb;